@if (!data().redacted) {
  @if (data().gross) {
    <mat-card>
      <mat-card-content>
        <span class="title">Bestellübersicht</span>

        <ui-order-overview-details [minimumOrderValue]="minimumOrderValue()" [data]="data()"></ui-order-overview-details>
      </mat-card-content>
    </mat-card>

  }
}
